module.exports = __webpack_public_path__ + "static/media/bannerEsquentaBlackoutNormal.d934f20d.png";